import React from "react"

const CardIcon = ({ Icon, color }) => (
  <Icon className="is-size-1" style={{color}} />
)

export default CardIcon
